import type { AgentApiCandidateProfileTagsIndex } from '@/types/serializers';
import { useQuery } from '@tanstack/react-query';

export default function useCandidateProfileTags() {
  return useQuery({
    queryKey: ['/agent/api/candidate_profile_tags'],
    queryFn: async () => {
      const response = await fetch('/agent/api/candidate_profile_tags');
      const data: AgentApiCandidateProfileTagsIndex = await response.json();
      return {
        tags: data.records.map(({ id, name, color_hex }) => ({ id, name, colorHex: color_hex })),
      };
    },
  });
}
